import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
// material-ui components
import { TableCell, TableRow } from '@mui/material';
import { ScoringTextField } from '../styles/DocumentScoringStyles';
import { emptyString } from 'constants/emptyConst';
const DocumentScoringIndicatorListRowComponent = ({ idx, indicator, periodList, disabled, onFinancialIndicatorValueChange }) => {
  return (
    <TableRow>
      <TableCell>{indicator.name}</TableCell>
      {periodList.length > 0 &&
        periodList
          .filter(period => period.selected)
          .map(period => (
            <TableCell key={period.documentScoringFinancialIndicatorPeriodDimensionId}>
              <ScoringTextField
                inputProps={{ decimalScale: indicator.scale ? indicator.scale : 2 }}
                disabled={disabled}
                fullWidth
                isNumeric
                value={indicator.values[period.dimensionPeriodId] || emptyString}
                error={indicator.isMandatory && indicator.values[period.dimensionPeriodId] === null ? true : false}
                onChange={value => onFinancialIndicatorValueChange(idx, period.dimensionPeriodId, value) }
              />
            </TableCell>
          ))}
    </TableRow>
  );
};

DocumentScoringIndicatorListRowComponent.propTypes = {
  idx: PropTypes.number.isRequired,
  indicator: PropTypes.object.isRequired,
  periodList: PropTypes.array.isRequired,
  disabled: PropTypes.bool.isRequired,
  onFinancialIndicatorValueChange: PropTypes.func.isRequired
};

export default compose(withTranslation())(DocumentScoringIndicatorListRowComponent);
